export const RESIZE_LISTENER_DEBOUNCE_TIME_MS = 30;
